// src/pages/app/EventsPage.jsx
import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout'; 

const EventsPage = () => {
    
    const EventCard = ({ title, location, time, category }) => (
        <div className="event-card" style={{ border: '1px solid #ddd', padding: '20px', borderRadius: '8px', marginBottom: '15px', backgroundColor: 'white', display: 'flex', gap: '20px', alignItems: 'center' }}>
            <div style={{ flexShrink: 0, width: '60px', height: '60px', backgroundColor: 'var(--color-sky)', color: 'white', borderRadius: '6px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>14</span>
                <span style={{ fontSize: '0.8rem' }}>DEC</span>
            </div>
            <div>
                <h4 style={{ margin: '0 0 5px 0', fontSize: '1.1rem', color: 'var(--color-navy)' }}>{title}</h4>
                <p style={{ margin: '0', fontSize: '0.9rem', color: 'var(--color-gray-dark)' }}>[Location Icon] {location} • [Time Icon] {time}</p>
                <span style={{ fontSize: '0.8rem', color: 'var(--color-sky)', padding: '3px 8px', backgroundColor: 'var(--color-sky-light)', borderRadius: '4px', marginTop: '5px', display: 'inline-block' }}>{category}</span>
            </div>
        </div>
    );

    return (
        <DashboardLayout>
            <h1 className="dashboard-page-title">Local Events Calendar</h1>
            <p className="dashboard-page-subtitle">Find out what's happening in your neighborhood this week.</p>
            
            {/* Filter Bar */}
            <div className="filter-bar" style={{ display: 'flex', gap: '15px', marginBottom: '30px' }}>
                <input type="date" className="auth-input-field" style={{ width: '200px' }} />
                <select className="auth-input-field" style={{ width: '200px' }}>
                    <option>All Categories</option>
                    <option>Community Meetings</option>
                    <option>Arts & Culture</option>
                    <option>Local Government</option>
                </select>
                <button className="auth-button auth-primary-button" style={{ width: '100px', padding: '0 10px' }}>Filter</button>
            </div>

            {/* Event List */}
            <div className="event-list-container">
                <EventCard 
                    title="Community Board Meeting - January Agenda" 
                    location="Local Library Auditorium" 
                    time="6:00 PM" 
                    category="Local Government" 
                />
                <EventCard 
                    title="Winter Arts & Crafts Fair" 
                    location="1st Ave Public School" 
                    time="10:00 AM - 4:00 PM" 
                    category="Arts & Culture" 
                />
            </div>
        </DashboardLayout>
    );
};

export default EventsPage;